// extracted by mini-css-extract-plugin
export default {"wrapper":"yu-z","viewport":"zu-z","container":"Au-z","slide":"Bu-z"};